var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMenuBranca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.226,
    height: 76.668,
    viewBox: "0 0 180.226 76.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_161",
    "data-name": "Ret\\xE2ngulo 161",
    width: 180.226,
    height: 76.668,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1090",
    "data-name": "Grupo 1090",
    transform: "translate(0 20.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(0 -20.1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M3.719,42.052l20.317,11.73a7.437,7.437,0,0,1,2.722,10.159L19.41,76.668H59.381a7.437,7.437,0,0,0,6.441-3.719L82.089,44.774a7.438,7.438,0,0,0-2.722-10.159L59.051,22.885a7.438,7.438,0,0,1-2.724-10.16L63.675,0H23.7a7.435,7.435,0,0,0-6.44,3.719L1,31.893A7.438,7.438,0,0,0,3.719,42.052",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M73.788,34.9A7.844,7.844,0,0,0,79,36.985c1.6,0,2.561-.634,2.561-1.673V35.26c0-.989-.609-1.5-3.576-2.257-3.574-.911-5.881-1.9-5.881-5.426v-.05c0-3.221,2.586-5.35,6.211-5.35a9.855,9.855,0,0,1,6.467,2.157l-1.8,3.113a8.77,8.77,0,0,0-4.72-1.823c-1.5,0-2.283.686-2.283,1.547v.051c0,1.166.761,1.546,3.828,2.333,3.6.937,5.63,2.231,5.63,5.324v.05c0,3.526-2.736,5.5-6.517,5.5a13.107,13.107,0,0,1-6.96-2.372Z",
    transform: "translate(25.355 7.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M97.907,31.4v-.05a5.392,5.392,0,0,0-5.376-5.578A5.307,5.307,0,0,0,87.208,31.3v.051a5.391,5.391,0,0,0,5.376,5.577A5.308,5.308,0,0,0,97.907,31.4m-14.782,0v-.05A9.437,9.437,0,0,1,101.99,31.3v.051a9.437,9.437,0,0,1-18.865.05",
    transform: "translate(29.287 7.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M103.059,25.966h-5.4v-3.6h14.707v3.6h-5.4V40.114h-3.9Z",
    transform: "translate(34.408 7.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M110.2,22.365h13.388v3.474h-9.508v3.6h8.367v3.474h-8.367V36.64h9.634v3.474H110.2Z",
    transform: "translate(38.825 7.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M129.711,30.986c1.9,0,2.993-1.014,2.993-2.51v-.051c0-1.673-1.167-2.536-3.068-2.536h-3.88v5.1Zm-7.858-8.621h8.114a7.075,7.075,0,0,1,5.171,1.8,5.576,5.576,0,0,1,1.521,4.057v.051a5.511,5.511,0,0,1-3.8,5.5l4.337,6.34h-4.564l-3.8-5.68h-3.068v5.68h-3.9Z",
    transform: "translate(42.932 7.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M71.993,43h3.082v.8H72.887v.829h1.926v.8H72.887v.857H75.1v.8H71.993Z",
    transform: "translate(25.365 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M78.339,43h.829l1.915,2.517V43h.887v4.087h-.764l-1.98-2.6v2.6h-.887Z",
    transform: "translate(27.601 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M85.069,45.076v-.012a2.1,2.1,0,0,1,2.142-2.112,2.246,2.246,0,0,1,1.605.56l-.565.683a1.507,1.507,0,0,0-1.068-.414,1.227,1.227,0,0,0-1.174,1.273v.011a1.225,1.225,0,0,0,1.237,1.3,1.432,1.432,0,0,0,.847-.246v-.583h-.9v-.776h1.776v1.774a2.66,2.66,0,0,1-1.746.648,2.045,2.045,0,0,1-2.149-2.1",
    transform: "translate(29.972 15.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M92.04,43h3.082v.8H92.934v.829H94.86v.8H92.934v.857h2.218v.8H92.04Z",
    transform: "translate(32.429 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M98.386,43h.829l1.915,2.517V43h.887v4.087h-.764l-1.98-2.6v2.6h-.887Z",
    transform: "translate(34.664 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M105.25,43h.9V44.62h1.658V43h.9v4.087h-.9v-1.64h-1.658v1.64h-.9Z",
    transform: "translate(37.083 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M114.423,45.387l-.542-1.325-.544,1.325Zm-.945-2.406h.829l1.751,4.115h-.94l-.373-.916h-1.728l-.373.916h-.917Z",
    transform: "translate(39.364 15.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M120.657,44.987c.438,0,.69-.234.69-.579V44.4c0-.385-.269-.584-.707-.584h-.893v1.174ZM118.848,43h1.868a1.63,1.63,0,0,1,1.191.414,1.287,1.287,0,0,1,.35.934v.012a1.27,1.27,0,0,1-.875,1.267l1,1.459H121.33l-.876-1.308h-.706v1.308h-.9Z",
    transform: "translate(41.874 15.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_160",
    "data-name": "Ret\\xE2ngulo 160",
    width: 0.898,
    height: 4.087,
    transform: "translate(169.655 58.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M132.765,45.387l-.542-1.325-.544,1.325Zm-.945-2.406h.829L134.4,47.1h-.94l-.373-.916h-1.728l-.373.916h-.917Z",
    transform: "translate(45.827 15.143)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenuBranca);
export default __webpack_public_path__ + "static/media/logo_menu_branca.11e71f6418646887b67ef55e2911d12a.svg";
export { ForwardRef as ReactComponent };